import type {
  KycBannerServiceProvider,
  KycWarning,
} from '@pflegenavi/shared-frontend/platform';
import {
  getKycWarning,
  shouldShowKycBanner,
} from '@pflegenavi/shared-frontend/platform';

export interface ServiceProviderKycSubject extends KycBannerServiceProvider {
  kyc_renewal_deadline: string | null;
  mangopay_hosted_idv_enabled: boolean;
  hosted_idv_enabled: boolean;
}

/** Hosted IDV needs the rollout flag and the provider's own opt-in. */
export const isHostedIdvEnabled = (
  data: ServiceProviderKycSubject | undefined
): boolean =>
  Boolean(data?.mangopay_hosted_idv_enabled && data.hosted_idv_enabled);

/** Renewal warnings need hosted IDV, since a new session is how providers renew. */
export const getServiceProviderKycWarning = (
  data: ServiceProviderKycSubject | undefined,
  today: Date
): KycWarning | null => {
  if (!data || !isHostedIdvEnabled(data)) {
    return shouldShowKycBanner(data) ? 'not_verified' : null;
  }
  if (data.payment_service_provider !== 'mangopay' || !data.mangopay_user_id) {
    return null;
  }
  return getKycWarning(data, today);
};
